import {
  renderTime,
} from '../../userUtils';

const getCommon = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    id: productEventId,
    content,
  } = event;

  const {
    ackRequired,
    productId,
  } = content;

  const {
    criteria,
    issueTime: originalIssueTime,
  } = details;
  const issueTime = renderTime(originalIssueTime, userPreferences);

  const {
    severity: severityName,
    severityId,
  } = criteria;

  const status = '';
  const version = 0;
  const warningNumber = '';

  return {
    productEventId,
    productId,
    status,
    version,
    ackRequired,
    severityName,
    severityId,
    warningNumber,
    issueTime,
  };
};

const getListFeature = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    singularName: productName,
  } = productType;

  const {
    criteria,
    issueTime,
  } = details;

  const {
    eventType: criteriaName,
  } = criteria;

  const heading = {
    key: 'PRODUCT_DETAILS.PRODUCT_CARDS.HEADERS.STORM_REPORT_NOTIFICATIONS',
    params: {
      criteriaName,
    },
  };
  const subtitle = renderTime(issueTime, userPreferences);
  return {
    heading,
    subtitle,
  };
};

const getMapFeature = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    bbox,
    expireTime,
    issueTime,
    criteria,
  } = details;
  const {
    eventType: criteriaName,
  } = criteria;
  const {
    singularName: productName,
  } = productType;

  const heading = {
    key: 'PRODUCT_DETAILS.MAP.HEADERS.STORM_REPORT_NOTIFICATIONS',
  };

  const subtitle = criteriaName;
  const endTime = renderTime(expireTime, userPreferences);
  const startTime = renderTime(issueTime, userPreferences);
  const validTime = renderTime(issueTime, userPreferences);
  const isPointInTime = true;

  return {
    heading,
    subtitle,
    endTime,
    startTime,
    validTime,
    bbox,
    isPointInTime,
  };
};

const getState = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => {
  const {
    state,
  } = event;

  const {
    read,
    acked,
  } = state;

  return {
    read,
    acked,
    playingSound,
  };
};

const getFeatures = (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => ({
  map: getMapFeature(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  list: getListFeature(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
});


export default (
  productType,
  event,
  details,
  playingSound,
  severities,
  userPreferences,
) => ({
  common: getCommon(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  state: getState(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
  features: getFeatures(
    productType,
    event,
    details,
    playingSound,
    severities,
    userPreferences,
  ),
});
